import FirebaseContext from 'contexts/FirebaseContext';
import isEqual from 'lodash/isEqual';
import { useContext, useMemo, useRef } from 'react';

export default function useProcessTimeStampsNoOffset() {
  const firebase = useContext(FirebaseContext);
  const lastObjRef = useRef(null);

  const processTimestampsNoOffset = useMemo(() => {
    function process(obj) {
      if (obj instanceof firebase.admin.Timestamp) {
        return obj.toDate();
      }

      if (Array.isArray(obj)) {
        return obj.map(processTimestampsNoOffset);
      }

      if (typeof obj === 'object' && obj !== null) {
        for (let key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = process(obj[key]);
          }
        }
      }

      return obj;
    }

    return (obj) => {
      if (isEqual(obj, lastObjRef.current)) {
        return lastObjRef.current;
      }

      const processedObj = process(obj);
      lastObjRef.current = processedObj;
      return processedObj;
    };
  }, [firebase]);

  return processTimestampsNoOffset;
}
